import { useState, useCallback } from 'react';

export const useResourcePagination = (initialPage = 1) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  const onPageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  return { currentPage, onPageChange, setCurrentPage };
};
